import { gql } from "@apollo/client";

const GET_CLIENT_INVOICES = gql`
  query getClientInvoices(
    $clientIdentifier: String!
    $sortBy: InvoiceSortBy
    $sortDirection: SortDirection
    $invoiceDateFrom: Date
    $invoiceDateTo: Date
    $dueDateFrom: Date
    $dueDateTo: Date
    $invoiceStatuses: [InvoiceProcessStatus]
    $amountFrom: Decimal
    $amountTo: Decimal
    $tags: [String]
    $skip: Int
    $take: Int
    $clientFilterType: ClientFilterType
  ) {
    invoices(
      clientIdentifier: $clientIdentifier
      sortBy: $sortBy
      sortDirection: $sortDirection
      invoiceDateFrom: $invoiceDateFrom
      invoiceDateTo: $invoiceDateTo
      dueDateFrom: $dueDateFrom
      dueDateTo: $dueDateTo
      invoiceStatuses: $invoiceStatuses
      amountFrom: $amountFrom
      amountTo: $amountTo
      tags: $tags
      skip: $skip
      take: $take
      clientFilterType: $clientFilterType
    ) {
      totalCount
      items {
        id
        createdAt
        currencyCode
        dueDate
        invoiceDate
        invoiceFileId
        invoiceNumber
        invoiceRecipient {
          client {
            id
            name
          }
          name
        }
        invoiceIssuer {
          client {
            id
            name
          }
        }
        modifiedAt
        originalInvoiceFileId
        sentFromErpToRecipientAt
        totalAmountWithVat
        state {
          assessmentStatus
          processStatus
          registrationStatus
          validationStatus
        }
        tags {
          invoiceTagId
          tag
        }
        hasDuplicateInvoices
        isCreditInvoice
      }
    }
  }
`;

export default GET_CLIENT_INVOICES;
